import { ButtonProps, CircularProgress, SxProps, Theme } from '@mui/material'
import ButtonMUI from '@mui/material/Button'

interface CustomProps {
  title?: string
  outlined?: boolean
  gradient?: boolean
  backgroundColor?: string
  color?: string
  fullWidth?: boolean
  fontSize?: string
  sx?: SxProps<Theme>
  loading?: boolean
}

export const Button = ({
  title,
  outlined,
  gradient,
  backgroundColor,
  color,
  fontSize,
  fullWidth,
  sx,
  loading,
  ...rest
}: CustomProps & ButtonProps) => {
  return (
    <ButtonMUI
      sx={{
        minWidth: '100px',
        borderRadius: '100px',
        padding: '.5rem 1.5rem',
        fontFamily: 'Titillium Web',
        fontWeight: 600,
        cursor: 'pointer',
        textTransform: 'none',
        fontSize: fontSize || 'inherit',
        width: fullWidth ? '100%' : 'auto',
        border: outlined ? '1px solid #6633CC' : 'none',
        color: color || (outlined ? '#6633CC' : '#FFFFFF'),
        background:
          backgroundColor ||
          (gradient
            ? 'linear-gradient(91.95deg, #6633CC 4.33%, #00CC99 149.49%)'
            : outlined
              ? 'transparent'
              : '#6633CC'),

        ...sx,
      }}
      variant={outlined ? 'outlined' : gradient ? 'text' : 'contained'}
      {...rest}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : title}
    </ButtonMUI>
  )
}
